export default __webpack_public_path__ + "static/logo-52f904b4955c95cd047ce5ea7548caff.svg";